module.exports = new __parcel__URL__("jpd-timeline-blank-darkmode.c68a6cba.svg").toString();